import { withStyles, TableCell } from '@material-ui/core';

export default withStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 2.5),
  },
}))(TableCell);
